var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudSpanner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-cloud-spanner",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M29.88,29.606V22.52H25.592v7.086L19.56,33.148l2.144,3.77,6.032-3.543,6.032,3.543,2.144-3.77Z",
    transform: "translate(-11.736 -13.37)",
    fill: "#669df6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M31.488,29.606V22.52H29.344v8.321l-7.1,4.193,1.072,1.885,6.032-3.543,6.032,3.543,2.144-3.77Z",
    transform: "translate(-13.344 -13.37)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M29.728,0,26.48,1.983V8.044l5.408,2.974V5.964l-2.16-1.008Z",
    transform: "translate(-15.888)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M18.16,4.957,16,5.964v5.054l5.408-2.974V1.983L18.16,0Zm7.664,18.3L25.7,25.515,30.016,28l-3.488,1.95-5.184-3.039.176-6.224,5.232-3.25L32,20.493V24.54l-4.3-2.519Zm-19.648,0L4.3,22.021,0,24.54V20.493l5.168-3.039L10.4,20.7l.176,6.224L5.472,30,1.984,28,6.3,25.466Z",
    fill: "#669df6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M32,50.069l-.08-4.047L26.752,43,21.52,46.267l4.3,2.519L27.68,47.55Zm-32,0L4.32,47.55l1.856,1.235,4.3-2.519L5.248,43,.08,46.023Z",
    transform: "translate(0 -25.53)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudSpanner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloudSpanner.e029063a54321155ccf34aca43ba1d20.svg";